import React, { useState } from "react";
import "./ClientRecommendationForm.scss";
import RecommendationModal from "./RecommendationInfo/RecommendationInfo";
import { useSelector, useDispatch } from "react-redux";
import { closeInfo, openInfo } from "../../../../store/Partner/modalSlice";
import BreadCrumb from "../../../../components/BreadCrumb/BreadCrumb";

const ClientRecommendationForm = () => {
  const dispatch = useDispatch();
  const showInfo = useSelector((state) => state.modal.showInfo);

  const [formData, setFormData] = useState({
    firstName: "",
    role: "",
    email: "",
    company: "",
    title: "",
    date: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    // TODO: Add your submit logic here (e.g. send to backend)
  };

  return (
    <>
      <div className="breadCrumb">
        <BreadCrumb
          paths={[
            { name: "Home", path: "/dashboard" },
            { name: "Client Recommendation", path: "" },
          ]}
        />
      </div>

      <div className="form-container">
        <div className="heading">
          <h2>Request a client recommendation</h2>
          <span
            className="query"
            onClick={() =>
              !showInfo ? dispatch(openInfo()) : dispatch(closeInfo())
            }
          >
            ?
          </span>
        </div>

        <p>Fill out your client’s details.</p>

        <form onSubmit={handleSubmit}>
          <div className="form-grid">
            <div className="form-group">
              <label>Client’s first name</label>
              <input
                type="text"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                placeholder="e.g. Adam"
              />
            </div>

            <div className="form-group">
              <label>Client’s role</label>
              <input
                type="text"
                name="role"
                value={formData.role}
                onChange={handleChange}
                placeholder="e.g. Project manager"
              />
            </div>

            <div className="form-group">
              <label>Business email address</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="e.g. aman@lodha.co.in"
              />
            </div>

            <div className="form-group">
              <label>Company name</label>
              <input
                type="text"
                name="company"
                value={formData.company}
                onChange={handleChange}
                placeholder="e.g. Lodha Group"
              />
            </div>

            <div className="form-group">
              <label>Project title</label>
              <input
                type="text"
                name="title"
                value={formData.title}
                onChange={handleChange}
                placeholder="e.g. Real Estate Shoot"
              />
            </div>

            <div className="form-group">
              <label>Project date</label>
              <input
                type="date"
                name="date"
                value={formData.date}
                onChange={handleChange}
                placeholder="e.g. 12/12/23"
              />
            </div>
          </div>

          <div className="form-group">
            <label>Message to client</label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder={`Hey Adam! How have you been? I wanted to ask you if you wouldn't mind writing a testimonial of my work with you? Thanks!`}
            ></textarea>
          </div>

          <div className="button-container">
            <button type="button" className="cancel-btn">
              Cancel
            </button>
            <button type="submit" className="send-btn">
              Send Request
            </button>
          </div>
        </form>
      </div>

      {showInfo && <RecommendationModal />}
    </>
  );
};

export default ClientRecommendationForm;
